import React, { Component } from 'react'
import { connect } from 'react-redux'

import ahcLoginRedirect from '../../utilities/profile/accor/ahcLoginRedirect'
import GuestForm from '../forms/guestForm/GuestForm'
import BkFlowMaterialLoader from '../elements/BkFlowMaterialLoader'

import { TARS_PROVIDER } from '../../config/config'

import yn from 'yn'
import _ from 'lodash'

class BkFlowPaymentForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			configData,
			currentQueryData,
			formData,
			isGuestPrefixRequired,
			isProfileAuthenticated,
			profileUser,
			profileUserLoading
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		let initialGuestValues = {}

		// Pre-fill guest for based on local storage profiles
		if (localStorage.flowGuestProfiles) {
			const flowGuestProfiles = JSON.parse(localStorage.flowGuestProfiles)
			const primaryGuest = flowGuestProfiles[0]

			initialGuestValues = {
				prefix: primaryGuest.prefix,
				firstName: primaryGuest.firstName,
				lastName: primaryGuest.lastName,
				email: primaryGuest.email,
				phone: primaryGuest.phone,
				city: primaryGuest.city,
				stateProv: primaryGuest.stateProv,
				country: primaryGuest.country
			}
		} else if (!profileUserLoading && isProfileAuthenticated && profileUser) {
			initialGuestValues = {
				prefix: profileUser.prefix,
				firstName: profileUser.firstName,
				lastName: profileUser.lastName,
				email: profileUser.email,
				phone: profileUser.phone,
				address1: profileUser.address1,
				city: profileUser.city,
				stateProv: profileUser.stateProv,
				country: process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY_DEFAULT ? process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY_DEFAULT : '0'
			}
		} else {
			// Pre-fill country value
			initialGuestValues = {
				firstName: '',
				country: process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY_DEFAULT ? process.env.REACT_APP_COMPONENT_GUEST_FORM_COUNTRY_DEFAULT : '0',
				stateProv: 0
			}
		}

		let baseClassNames = 'bk-flow-payment__form default'

		if (process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT) {
			baseClassNames = 'bk-flow-payment__form ' + process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT
		}

		return (
			<div className={baseClassNames}>
				<div className="u-form-card">
					<h3 className="bk-flow-payment__form-heading">
						<span className="bk-flow-payment__form-heading-content">{ hotelLabels.primaryGuestInformation ? hotelLabels.primaryGuestInformation : 'Primary Guest Information' }</span>
						{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_PROFILE_TOGGLE) &&
							!isProfileAuthenticated &&
							!profileUserLoading &&
							!profileUser &&
								<button
									className="bk-flow-payment__profile-modal-toggle"
									onClick={() => ahcLoginRedirect(currentQueryData)}
								>
									{hotelLabels.signUpLogIn ? hotelLabels.signUpLogIn : 'Sign-Up / Log-In'}
								</button>
						}
					</h3>
					<p className="u-txt-left">{ hotelLabels.requiredFieldsDisclaimer ? hotelLabels.requiredFieldsDisclaimer : 'All information marked with (*) is required' }</p>

					{ profileUserLoading ?
						<BkFlowMaterialLoader />
					:
						<GuestForm
							form="guestForm"
							configData={ configData }
							initialValues={ initialGuestValues }
							isGuestPrefixRequired={ isGuestPrefixRequired }
							formData={ formData }
						/>
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		currentQueryData: state.availabilityData.currentQueryData,
		formData: state.form,
		profileUser: state.profileUserData.user,
		profileUserLoading: state.profileUserData.loading,
		isGuestPrefixRequired: _.toInteger(_.get(state, 'availabilityData.urlData.hotelProvider')) === TARS_PROVIDER,
		isProfileAuthenticated: state.profileData.isProfileAuthenticated,
	}
}

export default connect(mapStateToProps, null)(BkFlowPaymentForm)


// WEBPACK FOOTER //
// ./src/components/payment/BkFlowPaymentForm.js